import { styled } from '@mui/material';
import { Grid } from '@mui/system';

const PREFIX = 'FloatingButtonGroup';

export const classes = {
  buttonGroup: `${PREFIX}-buttonGroup`,
  button: `${PREFIX}-button`,
  icon: `${PREFIX}-icon`,
  label: `${PREFIX}-label`,
};

export const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.buttonGroup}`]: {
    marginTop: '1.5em',
    backgroundColor: theme.palette.white,
  },

  [`& .${classes.button}`]: {
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: 3,
  },

  [`& .${classes.icon}`]: {
    paddingRight: theme.spacing(1),
  },

  [`& .${classes.label}`]: {
    fontSize: '15px',
    fontWeight: 'bold',
  },
}));